module.exports = __webpack_public_path__ + "static/logo_nomad-8498e5c192b488c64e68d0419553b7bb.png";